export enum Section {
    RBC = 'RBC',
    IRON = 'Iron',
    WBC = 'WBC',
    PLATELETS = 'Platelets',
    GLUCOSE = 'Glucose',
    KIDNEY = 'Kidney',
    NUTRIENTS = 'Nutrients',
    ELECTROLYTES = 'Electrolytes',
    PROTEINS = 'Proteins',
    LIVER_BILIARY = 'Liver / Biliary',
    LIPIDS = 'Lipids',
    INFLAMMATION_OXIDATIVE_STRESS = 'Inflammation / Oxidative Stress',
    THYROID = 'Thyroid',
    SEX_HORMONE = 'Hormones',
    PROSTATE = 'Prostate',
    NOTES = 'Notes'
}
